export default __webpack_public_path__ + "static/media/Optimized-pexels-fauxels-3183188.3120ce7a.jpg";